import { george, observer, pr, React, theme, ui } from "aaa";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { ShowCardDataRoutes } from "./ShowCardDataRoutes";

const DIV_16_CONTENT = ({ children }: { children: React.ReactNode }) => <div className="theme-paragraph-color">{children}</div>;

export const ShowCardDataSuccess = observer(() => {
    const useWebVersion = true;

    React.useEffect(() => {
        window.scrollTo(0, 0);

        if (!useWebVersion || externalInterfaceStore.isGeorgeApp) {
            document.body.style.backgroundColor = theme.headerBackgroundColor(ui.isDarkMode);
        }

        return () => {
            document.body.style.backgroundColor = "";
        };
    }, [externalInterfaceStore.isGeorgeApp]);

    const handleDismiss = () => {
        externalInterfaceStore.raiseExitSuccess("showCardData");
    };

    const handleDisplayAgain = () => {
        pushRoute(ShowCardDataRoutes.ROOT);
    };

    const iconSize = Math.min(ui.windowWidth * 0.4, theme.HEADER_ICON_SIZE);

    const isGeorgeApp = externalInterfaceStore.isGeorgeApp;

    let BackgroundComponent = george.MessageScreenBackground;
    let MessageTextComponent = pr.MessageScreenText;
    let textColor: string | undefined = "white";
    let iconColor = "white";
    let marginTop = 20;
    let titleClassName;
    let bottomMargin = 100;

    const isWebVersion = useWebVersion && !isGeorgeApp;
    const showAppButton = !isWebVersion;
    const showWebButton = isWebVersion;

    if (isWebVersion) {
        BackgroundComponent = george.Card;
        MessageTextComponent = DIV_16_CONTENT;
        textColor = undefined;
        iconColor = theme.themeColors.ui_green;
        marginTop = 50;
        titleClassName = "theme-title-color";
        bottomMargin = 50;
    }

    return (
        // Outer VFlex is because of IE, without it the justify-content: center of george.MessageScreenBackground does not work
        // See https://stackoverflow.com/a/29270539/677910
        <pr.VFlex>
            <BackgroundComponent
                style={{
                    marginTop: isWebVersion ? theme.HEADER_CONTENT_SPACING : undefined,
                }}
            >
                <pr.VFlex style={{ textAlign: "center" }}>
                    <div style={{ marginTop }}>

                        {/* <pr.GeorgeIconWrapper
                                color="white"
                                size={iconSize}
                                iconName="#ico-check-circle"
                            /> */}
                        <pr.IconMessageOk style={{ width: iconSize, height: iconSize, color: iconColor }} />
                    </div>
                    <pr.MessageLabelContainer>
                        <pr.H1WithFocus
                            style={{
                                fontSize: 24,
                                // fontSize: Math.min(0.06 * ui.windowWidth, 28)
                                fontWeight: 600,
                                color: textColor,
                            }}
                            className={titleClassName}
                        >
                            {ui.__("showCardData.success.title")}
                        </pr.H1WithFocus>
                    </pr.MessageLabelContainer>
                    <pr.MessageLabelContainer>
                        <MessageTextComponent>
                            {/* some text */}
                        </MessageTextComponent>
                    </pr.MessageLabelContainer>

                </pr.VFlex>

                {/* Filler for Button, not using padding, because it grows outer div */}
                {(!isWebVersion || !showWebButton) &&
                    <div style={{ height: bottomMargin }} />
                }

                {showAppButton &&
                    <>
                        <george.SuccessButton
                            label={ui.__("showCardData.success.button.text")}
                            onClick={handleDisplayAgain}
                        // style={{ bottom: theme.ACTION_BUTTON_HEIGHT }}
                        />
                        {/* <george.SecondaryActionButton
                            messageId="common.backToGeorgeGo"
                            onClick={handleDismiss}
                            style={{
                                paddingTop: theme.MARGIN,
                                paddingBottom: theme.MARGIN,
                                width: "100%",
                                maxWidth: theme.MAX_APP_WIDTH,
                                backgroundColor: "transparent",
                                fontSize: 16,
                                color: "white",
                                fontWeight: "bold"
                            }}
                        />*/}
                    </>
                }
                {showWebButton &&
                    <>
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        <george.ActionButton
                            messageId="showCardData.success.button.text"
                            onClick={handleDisplayAgain}
                            inline
                            style={{ padding: theme.MARGIN, paddingBottom: theme.MARGIN_LARGE }}
                        />
                    </>
                }
            </BackgroundComponent>
        </pr.VFlex>
    );
});



// WEBPACK FOOTER //
// ./src/components/showCardData/ShowCardDataSuccess.tsx